import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {MdMarket} from '../../models/mdMarket';
import {DadProduct} from '../../models/dadProduct';
import * as _ from 'lodash';
import {DadProductService} from '../../services/dad-product.service';

@Component({
  selector: 'app-dad-product-crud',
  templateUrl: './dad-product-crud.component.html',
  styleUrls: ['./dad-product-product.component.scss']
})
export class DadProductCrudComponent implements OnInit {

  dadProductForm: UntypedFormGroup;
  marketsList: SelectItem[] = [];
  productTypesList: SelectItem[];
  selectedMarket: MdMarket;
  selectedDadProduct: DadProduct;
  isEditDadProduct: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private dadProductService: DadProductService) {
  }

  ngOnInit() {
    this.initLocalVars();
    this.createFormGroup();
    this.initSelectLists();
    this.initialiseFormGroup();
  }

  private initialiseFormGroup() {
    _.forEach(this.config.data['markets'], (market: MdMarket) => {
      this.marketsList.push({
        label: market.name,
        value: market.name
      });
    });
    this.dadProductForm.get('market').setValue(this.selectedMarket.name);
    // tslint:disable-next-line:max-line-length
    this.dadProductForm.get('productType').setValue(this.selectedDadProduct ? this.selectedDadProduct.productType : 'Standard product code');
    this.dadProductForm.get('productCode').setValue(this.selectedDadProduct ? this.selectedDadProduct.productCode : null);
    this.dadProductForm.get('startDate').setValue(this.selectedDadProduct ? new Date(this.selectedDadProduct.startDate) : new Date());
  }

  private initLocalVars() {
    this.isEditDadProduct = this.config.data['isEditDadProduct'];
    this.selectedMarket = this.config.data['selectedMarket'];
    this.selectedDadProduct = this.config.data['selectedDadProduct'];
  }

  createFormGroup() {
    this.dadProductForm = this.formBuilder.group(
      {
        market: [{value: '', disabled: this.isEditDadProduct}],
        productType: [''],
        productCode: ['', Validators.required],
        startDate: [new Date()],
        id: ['']
      },
    );
  }

  initSelectLists() {
    this.productTypesList = [
      {label: 'Standard product code', value: 'Standard product code'},
      {label: 'Standard POP product code', value: 'Standard POP product code'},
      {label: 'Internal product code', value: 'Internal product code'},
      {label: 'Internal POP product code', value: 'Internal POP product code'},
      {label: 'Subvendor product code', value: 'Subvendor product code'},
      {label: 'Subvendor POP product code', value: 'Subvendor POP product code'},
      {label: 'Zero Dollar product code', value: 'Zero Dollar product code'},
    ];
  }

  onSubmit() {
    if (!this.dadProductForm.valid) {
      return;
    }
    if (this.isEditDadProduct) {
      this.editDadProduct();
      return;
    }
    this.addDadProduct();
  }

  private addDadProduct() {
    this.dadProductService.createDadProduct(this.dadProductForm.value).subscribe(
      res => {
        this.dadProductForm.get('id').setValue(res['id']);
        this.ref.close(this.dadProductForm.value);
      }
    );
  }

  private editDadProduct() {
    this.selectedDadProduct.productType = this.dadProductForm.get('productType').value;
    this.selectedDadProduct.startDate = this.dadProductForm.get('startDate').value;
    this.selectedDadProduct.productCode = this.dadProductForm.get('productCode').value;
    this.dadProductService.editDadProduct(this.selectedDadProduct).subscribe(
      () => {
        this.ref.close(this.selectedDadProduct);
      }
    );
  }
}
